<div class="flex flex-center auth-container">
    @if(messageView){
        <div class="flex flex-center">
            <sa-message-view [props]="messageView" (onClick)="onMessageViewEvent($event)"></sa-message-view>
        </div>
    }@else{
        <sa-spinner size="80">

        </sa-spinner>
    }
</div>